import { createSelector } from 'reselect';
import { KEY } from './';
import { GlobalState } from 'store/types';

const getHardwareState = (state: GlobalState) => state[KEY];

const selectHardware = createSelector(getHardwareState, (state) => state.hardware);

const selectAction = createSelector(getHardwareState, (state) => state.action);

const selectCreatedHardware = createSelector(getHardwareState, (state) => state.createdHardware);

export const selectors = {
  selectHardware,
  selectAction,
  selectCreatedHardware
};
